import { useDispatch, useSelector } from "react-redux";
import { getContentKeyAccToLang } from "../../utils/utils";
import dynamicfunction from "../../utils/dynamicfunction";
import { useEffect } from "react";
import { getMyFunds } from "../../store/actions/fund-action";

export default () => {
  const dispatch = useDispatch();
  const { TextWeight, isArabic, direction } = dynamicfunction();

  const { investmentContent } = useSelector((state) => state.content);
  const { my_funds, fund_loading } = useSelector((state) => state.fund);

  useEffect(() => {
    dispatch(getMyFunds());
  }, [])

  const getContentKey = (key) => {
    return getContentKeyAccToLang(investmentContent?.web_investment_fund?.data?.attributes, key, isArabic);
  };

  return {
    TextWeight,
    getContentKey,
    my_funds,
    fund_loading,
    direction
  }
}